import React, { useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Button,
} from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

const APP_DEEP_LINK = "ekalsutraparentapp://app/pay-fee";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ekalsutraparentapp";

const PayFee = () => {
  useEffect(() => {
    window.location.href = APP_DEEP_LINK;

    const timer = setTimeout(() => {
      if (document.visibilityState === "visible") {
        window.location.href = PLAY_STORE_URL;
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
          px: 3,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <PhoneAndroidIcon sx={{ fontSize: 40, color: "white" }} />
        </Box>

        <Typography
          variant="h5"
          fontWeight={600}
          color="text.primary"
          gutterBottom
        >
          Opening Ekalsutra Parent App
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Please wait while we redirect you...
        </Typography>

        <CircularProgress size={32} sx={{ mb: 4 }} />

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          App didn&apos;t open?
        </Typography>

        <Button
          variant="contained"
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          size="large"
          sx={{ textTransform: "none", px: 3 }}
        >
          Install from Play Store
        </Button>
      </Box>
    </Container>
  );
};

export default PayFee;
